<template>
  <div class="bg-gradient-to-br from-psychology-primary-5 to-psychology-secondary-5 rounded-2xl p-8 border-2 border-psychology-primary-20">
    <div class="text-center">
      <!-- 爱心图标 -->
      <div class="mb-6">
        <div class="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-psychology-primary to-psychology-secondary shadow-lg">
          <span class="text-4xl">💕</span>
        </div>
      </div>

      <!-- AYP指数标题 -->
      <h2 class="text-2xl font-bold text-gray-900 mb-2">你的AYP指数</h2>
      <p class="text-gray-600 mb-6">Age-gap Yearning Preference Index</p>

      <!-- 圆形进度条 -->
      <div class="relative inline-flex items-center justify-center mb-6">
        <svg class="transform -rotate-90" width="200" height="200">
          <!-- 背景圆 -->
          <circle
            cx="100"
            cy="100"
            r="90"
            stroke="#E5E7EB"
            stroke-width="12"
            fill="none"
          />
          <!-- 进度圆 -->
          <circle
            cx="100"
            cy="100"
            r="90"
            :stroke="scoreColor"
            stroke-width="12"
            fill="none"
            :stroke-dasharray="circumference"
            :stroke-dashoffset="dashOffset"
            stroke-linecap="round"
            class="transition-all duration-1000 ease-out"
          />
        </svg>
        <!-- 中心分数 -->
        <div class="absolute inset-0 flex flex-col items-center justify-center">
          <div class="text-5xl font-bold" :style="{ color: scoreColor }">
            {{ score }}
          </div>
          <div class="text-sm text-gray-600 mt-1">分</div>
        </div>
      </div>

      <!-- 倾向等级 -->
      <div class="mb-6">
        <div 
          class="inline-block px-6 py-3 rounded-full text-white font-semibold text-lg shadow-lg"
          :style="{ background: `linear-gradient(135deg, ${scoreColor}, ${scoreColor}dd)` }"
        >
          {{ levelText }}
        </div>
      </div>

      <!-- 能量条 -->
      <div class="max-w-md mx-auto">
        <div class="flex justify-between text-sm text-gray-600 mb-2">
          <span>年下倾向 🧒</span>
          <span>年上倾向 🧓</span>
        </div>
        <div class="relative h-8 bg-gradient-to-r from-psychology-secondary via-gray-200 to-psychology-primary rounded-full overflow-hidden shadow-inner">
          <div 
            class="absolute top-0 left-0 h-full w-1 bg-white shadow-lg transition-all duration-1000"
            :style="{ left: `calc(${score}% - 2px)` }"
          >
            <div class="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-white px-2 py-1 rounded shadow-md text-xs font-semibold whitespace-nowrap">
              {{ score }}分
            </div>
          </div>
        </div>
      </div>

      <!-- 简短描述 -->
      <p class="mt-6 text-gray-700 leading-relaxed max-w-lg mx-auto">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script>
import { getAYPLevel, getAYPDescription } from '@/utils/aypCalculator'

export default {
  name: 'AYPScoreDisplay',
  props: {
    score: {
      type: Number,
      required: true,
      validator: (value) => value >= 0 && value <= 100
    }
  },
  data() {
    return {
      circumference: 2 * Math.PI * 90 // 2πr
    }
  },
  computed: {
    dashOffset() {
      const progress = this.score / 100
      return this.circumference * (1 - progress)
    },
    scoreColor() {
      if (this.score >= 80) return '#FF3366' // 极强年上 - 红色
      if (this.score >= 60) return '#FF6B9C' // 明显年上 - 浅红
      if (this.score >= 40) return '#9C27B0' // 平衡型 - 紫色
      if (this.score >= 20) return '#6B9CFF' // 明显年下 - 浅蓝
      return '#3366FF' // 极强年下 - 蓝色
    },
    levelText() {
      return getAYPLevel(this.score)
    },
    description() {
      return getAYPDescription(this.score)
    }
  }
}
</script>

